<template>
  <BOverlay
    v-bind="$attrs"
    :variant="variant as any"
    :spinner-variant="spinnerVariant as any"
    :rounded="rounded"
    :opacity="opacity"
    :no-fade="noFade"
  >
    <slot />
  </BOverlay>
</template>

<script setup lang="ts">
import {BOverlay} from 'bootstrap-vue-next'

withDefaults(defineProps<{
  variant?: string
  spinnerVariant?: string
  rounded?: boolean
  opacity?: string
  noFade?: boolean
}>(), {
  variant: 'gray',
  spinnerVariant: 'primary',
  rounded: true,
  opacity: '.7',
  noFade: true
})
</script>
